module.exports = __webpack_public_path__ + "img/unicorn.f5208ffb.png";